export const TRANSITIONS = {
    assign: { from: ['OPEN'], to: 'ASSIGNED', roles: ['ADMIN', 'MANAGER'], needsMechanic: true, label: 'Assign' },
    reassign: {
        from: ['ASSIGNED', 'IN_PROGRESS'],
        to: 'ASSIGNED',
        roles: ['ADMIN', 'MANAGER'],
        needsMechanic: true,
        needsReason: true,
        label: 'Reassign',
    },
    hold: { from: ['IN_PROGRESS'], to: 'ON_HOLD', roles: ['MANAGER', 'MECHANIC'], needsHoldReason: true, label: 'Put On Hold' },
    resume: { from: ['ON_HOLD'], to: 'IN_PROGRESS', roles: ['MANAGER', 'MECHANIC'], label: 'Resume' },
    ready: { from: ['IN_PROGRESS'], to: 'READY_FOR_REVIEW', roles: ['MANAGER', 'MECHANIC'], label: 'Ready for Review' },
    sendBack: { from: ['READY_FOR_REVIEW'], to: 'IN_PROGRESS', roles: ['MANAGER'], needsReason: true, label: 'Send Back' },
    close: { from: ['READY_FOR_REVIEW'], to: 'CLOSED', roles: ['ADMIN', 'MANAGER'], label: 'Close' },
    reopen: { from: ['CLOSED'], to: 'IN_PROGRESS', roles: ['ADMIN', 'MANAGER'], needsReason: true, label: 'Reopen' },
};
export function checkTransition(action, actor, status) {
    const rule = TRANSITIONS[action];
    if (!rule.roles.includes(actor.role) || (actor.role === 'MECHANIC' && !actor.isAssignee)) {
        return { ok: false, code: 'FORBIDDEN', message: `${actor.role} may not ${rule.label}` };
    }
    if (!rule.from.includes(status)) {
        return { ok: false, code: 'BAD_STATUS', message: `Can't ${rule.label} a job that is ${status}` };
    }
    return { ok: true };
}
export function allowedActions(actor, status) {
    return Object.keys(TRANSITIONS).filter((a) => checkTransition(a, actor, status).ok);
}
// ---- voids: a second person always approves (docs/01; OPEN_QUESTIONS D9) ----
const VOID_ROLES = ['ADMIN', 'MANAGER'];
export function canRequestVoid(role, status) {
    if (!VOID_ROLES.includes(role))
        return { ok: false, code: 'FORBIDDEN', message: 'Only Manager or Admin may request a void' };
    if (status === 'CLOSED' || status === 'VOIDED') {
        return { ok: false, code: 'BAD_STATUS', message: `Can't void a job that is ${status}` };
    }
    return { ok: true };
}
export function canDecideVoid(role, userId, requestedBy) {
    if (!VOID_ROLES.includes(role))
        return { ok: false, code: 'FORBIDDEN', message: 'Only Manager or Admin may decide a void' };
    if (userId === requestedBy)
        return { ok: false, code: 'FORBIDDEN', message: 'Nobody approves their own void request' };
    return { ok: true };
}
//# sourceMappingURL=workflow.js.map